import './page-loader.css';

import * as React from 'react';
import { connect } from 'react-redux';

import { IRootState } from 'app/shared/reducers';

export const BookSpinner = () => (
  <div className="book-spinner" aria-hidden="true">
    <span />
    <span />
    <span />
    <span />
  </div>
);

export interface IPageLoaderProps {
  loading: boolean;
}

export interface IPageLoaderState {
  visible: boolean;
}

// Shows while any API request is running. The CSS delay stops it flashing on quick requests,
// and the short hold keeps it steady when one request follows straight after another.
export class PageLoader extends React.Component<IPageLoaderProps, IPageLoaderState> {
  state: IPageLoaderState = { visible: this.props.loading };

  hideTimer = null;

  componentDidUpdate(prevProps: IPageLoaderProps) {
    if (this.props.loading === prevProps.loading) {
      return;
    }
    clearTimeout(this.hideTimer);
    if (this.props.loading) {
      this.setState({ visible: true });
    } else {
      this.hideTimer = setTimeout(() => this.setState({ visible: false }), 250);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.hideTimer);
  }

  render() {
    // The book page has its own loader, and a background refresh must not cover an open book
    const onBookPage = window.location.hash.indexOf('#/home/') === 0;
    return this.state.visible && !onBookPage ? (
      <div className="page-loader" role="status" aria-live="polite">
        <BookSpinner />
        <p>Loading, please wait...</p>
      </div>
    ) : null;
  }
}

const mapStateToProps = ({ loadingBar }: IRootState) => ({
  loading: loadingBar.default > 0
});

export default connect(mapStateToProps)(PageLoader);
